import { Injectable, Injector } from '@angular/core';
import { ApiService } from '../../services/base-service/api.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ErrorUtil } from '../../helpers/error.utils';
import { NotificationsMessages } from './notifications-messages';

@Injectable({
    providedIn: 'root'
})
export class PlanTemplateService extends ApiService<any, any, any> {

    urlPath: string = 'plans'
    constructor(private Http: HttpClient, private Injector: Injector) {
        super(Http, Injector);
    }
    downloadFile(fileType, data, media) {
        if (navigator.onLine) {
            let options = {};

            if (fileType === 'XLSX') {
                const fileUrl = this.baseUrl + media + '/smartSearch/exportGrid/XLSX';
                options = { responseType: "arraybuffer" };
                return this.Http.post(fileUrl, data, options).pipe(map((response: any) => {
                    return response;
                }), catchError((err) => {
                    const errorObject = ErrorUtil.getErrorObject(err);
                    if (errorObject.code === 417 || errorObject.code === 412) {
                        this.notificationServcie.info(errorObject.message ? errorObject.message : NotificationsMessages.TRY_AGAIN, NotificationsMessages.INFORMATION);
                    } else {
                        this.notificationServcie.error(errorObject.message ? errorObject.message : NotificationsMessages.TECHNICAL_ISSUE, NotificationsMessages.ERROR)
                    }
                    return err;
                }));
            }
        }
    }
}